// extracted by mini-css-extract-plugin
export var carrierIcon = "_wc-0";
export var carrierLogo = "_wc-1";
export var detailsSection = "_wc-2";